import { Alert, Spin } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { getSupabaseClient } from "../lib/supabase";

export function AuthCallbackPage() {
	const navigate = useNavigate();
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const supabase = getSupabaseClient();
		const params = new URLSearchParams(window.location.search);
		const code = params.get("code");
		const type = params.get("type");

		async function exchange() {
			if (!code) {
				setError("認証コードが見つかりません。");
				return;
			}

			const { error: exchangeError } =
				await supabase.auth.exchangeCodeForSession(code);
			if (exchangeError) {
				setError(exchangeError.message);
				return;
			}

			if (type === "recovery") {
				navigate("/reset-password", { replace: true });
				return;
			}

			navigate("/users", { replace: true });
		}

		void exchange();
	}, [navigate]);

	if (error) {
		return (
			<div style={{ padding: 48 }}>
				<Alert type="error" message={error} showIcon />
			</div>
		);
	}

	return (
		<div
			style={{
				minHeight: "100vh",
				display: "grid",
				placeItems: "center",
			}}
		>
			<Spin size="large" tip="サインインを完了しています…" />
		</div>
	);
}
